import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridOperationItemsConfig} from './getAccountingMatrixDatagridOperationItemsConfig';

export function AccountingMatrixDatagridOperationItems() {
  return (
    <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridOperationItemsConfig()} />
  );
}
